import type {
	LocationDraft,
	ServicingSitePick,
	ShipToCheckpoint
} from "~fulfill/customers/customer/helpers/locationDraft";

import isRecord from "~/helpers/isRecord";

const isServicingSitePick = (value: unknown): value is ServicingSitePick =>
	isRecord(value) &&
	typeof value.name === "string" &&
	(value.siteLocationId === null || typeof value.siteLocationId === "string");

const isLocationDraft = (value: unknown): value is LocationDraft =>
	isRecord(value) &&
	isRecord(value.form) &&
	typeof value.form.id === "string" &&
	isRecord(value.form.address) &&
	Array.isArray(value.salesPeopleEmails) &&
	Array.isArray(value.orderEmailContactIds) &&
	typeof value.billingPermission === "boolean" &&
	typeof value.locationPermission === "boolean" &&
	(value.createdScheduleId === null || typeof value.createdScheduleId === "string") &&
	(value.receivingEmail === null || typeof value.receivingEmail === "string") &&
	(value.servicingSitePick === null || isServicingSitePick(value.servicingSitePick));

const isShipToCheckpoint = (value: unknown): value is ShipToCheckpoint =>
	isRecord(value) && typeof value.locationId === "string" && isLocationDraft(value.draft);

export default isShipToCheckpoint;
